import { render, staticRenderFns } from "./PrivacyPolicyGb.vue?vue&type=template&id=14b6984f&"
import script from "./PrivacyPolicyGb.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyGb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports